import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Alert,
    Button,
    Card,
    CardContent,
    Chip,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { API_URL } from "../config";

export default function UserManagement() {
    const [users, setUsers] = useState([]);
    const [form, setForm] = useState({ email: "", displayName: "", password: "" });
    const [message, setMessage] = useState(null);

    async function loadUsers() {
        const response = await axios.get(`${API_URL}/auth/users`, { withCredentials: true });
        setUsers(response.data.users || []);
    }

    useEffect(() => {
        loadUsers().catch((error) => setMessage({ severity: "error", text: error.response?.data?.error || "Unable to load users." }));
    }, []);

    async function createUser(event) {
        event.preventDefault();
        setMessage(null);
        try {
            await axios.post(`${API_URL}/auth/users`, form, { withCredentials: true });
            setForm({ email: "", displayName: "", password: "" });
            setMessage({ severity: "success", text: "User created." });
            await loadUsers();
        } catch (error) {
            setMessage({ severity: "error", text: error.response?.data?.error || "Unable to create user." });
        }
    }

    return (
        <Stack spacing={3}>
            <BoxHeader />
            {message && <Alert severity={message.severity}>{message.text}</Alert>}
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 5 }}>
                    <Card>
                        <CardContent component="form" onSubmit={createUser}>
                            <Stack spacing={2}>
                                <Typography variant="h6">Add staff account</Typography>
                                <TextField required label="Work email" type="email" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} />
                                <TextField required label="Display name" value={form.displayName} onChange={(event) => setForm({ ...form, displayName: event.target.value })} />
                                <TextField required label="Temporary password (12+ characters)" type="password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} />
                                <Button type="submit" variant="contained" startIcon={<PersonAddAltIcon />}>Create account</Button>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={{ xs: 12, md: 7 }}>
                    <Card>
                        <CardContent>
                            <Stack spacing={1.5}>
                                <Typography variant="h6">Team access</Typography>
                                {users.map((user) => (
                                    <Stack key={user.id} direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 1, borderBottom: 1, borderColor: "divider" }}>
                                        <Stack>
                                            <Typography fontWeight={700}>{user.display_name}</Typography>
                                            <Typography variant="body2" color="text.secondary">{user.email}</Typography>
                                        </Stack>
                                        <Chip size="small" label={user.active ? user.role : "inactive"} color={user.active ? "primary" : "default"} />
                                    </Stack>
                                ))}
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Stack>
    );
}

function BoxHeader() {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
            <Stack spacing={0.5}>
                <Typography variant="overline" color="primary.main" sx={{ letterSpacing: ".16em", fontWeight: 800 }}>ADMINISTRATION</Typography>
                <Typography variant="h4">User management</Typography>
                <Typography color="text.secondary">Control who can access the PBR Core internal portal.</Typography>
            </Stack>
        </Stack>
    );
}
